function JoyTycoonLoader(from_php){
    var loaderMain = new PIXI.loaders.Loader()
    this.loaderMain=loaderMain;
    _moduleEvents.on("moduleClear",function () {
        loaderMain.reset();
    });
    this.from_php=from_php;
}
JoyTycoonLoader.prototype={
    init:function(){
        var loaderMain=this.loaderMain;
        var from_php=this.from_php;
        
        var client_id,id,bum,likes,i,factory_id,add_id;  

        from_php.configs.factory={};
        from_php.configs.add={};
        from_php.configs.plateConfigItems={};
        var addImages={
            "creamCover":_IMG_SERV+"/gfx/place/easter2020/game/creamCover.png",
            "timerBox":_IMG_SERV+"/gfx/place/easter2020/game/timer/timerBox.png",
            "comboBox":_IMG_SERV+"/gfx/place/easter2020/game/combo/comboBox.png",
            "pointBox":_IMG_SERV+"/gfx/place/easter2020/game/combo/pointBox.png",
            "customerHate":_IMG_SERV+"/gfx/place/easter2020/game/hate.png",
            "tutorial_back":_IMG_SERV+"/gfx/place/easter2020/game/tutorial/back.png",
            "tutorial_arrow":_IMG_SERV+"/gfx/place/easter2020/game/tutorial/arrow.png",
            "cumBox":_IMG_SERV+"/gfx/place/easter2020/game/cumBar/border.png",
            "cumFill":_IMG_SERV+"/gfx/place/easter2020/game/cumBar/fill.png"
        };
        var need={ice_ids:{},add_ids:{},toy_ids:{}};
        if (typeof from_php.configs.customersConfig !== "undefined") {
            for(i=1;i<=from_php.configs.general.customer_id_max;i++){
                addImages["customer"+i]=_IMG_SERV+"/gfx/place/easter2020/game/girl/"+i+".png";
                for(id=1;id<=3;id++){
                    addImages["customer"+i+"_tent"+id]=_IMG_SERV+"/gfx/place/easter2020/game/girl/tent/"+id+"/"+i+"/skeleton.json";
                }
                for(id=1;id<=2;id++){
                    addImages["customer"+i+"_cum"+id]=_IMG_SERV+"/gfx/place/easter2020/game/girl/cum/"+id+"/"+i+"/skeleton.json";
                }
            }
            for (client_id in from_php.configs.customersConfig) {
                
                likes=from_php.configs.customersConfig[client_id].likes;
                for(i in likes.toy_ids){
                    id=likes.toy_ids[i];
                    need.toy_ids[id]=id;
                }
                for(i in likes.ice_ids){
                    id=likes.ice_ids[i];
                    need.ice_ids[id]=id;
                }
                for(i in likes.add_ids){
                    id=likes.add_ids[i];
                    need.add_ids[id]=id;
                }

            }
        }
        for(i=1;i<=4;i++){
            bum={img:"place"+i};
            from_php.configs.plateConfigItems[i]=bum;
            addImages[bum.img]=_IMG_SERV+"/gfx/place/easter2020/game/items_all/plate/"+i+".png";
        }
        for (id in from_php.configs.toysConfig) {
            bum = from_php.configs.toysConfig[id];
            if(typeof need.toy_ids[bum.toy_id]!="undefined"){
                bum.img="toy"+bum.toy_id;
                addImages[bum.img]=_IMG_SERV+"/gfx/place/easter2020/game/items_all/toy/"+bum.toy_id+".png";
            }
        }
        for(i=1;i<=2;i++){
             addImages["ice"+i]=_IMG_SERV+"/gfx/place/easter2020/game/items_all/ice/"+i+".png";
        }
        for(i=1;i<=3;i++){
            addImages["factory"+i]=_IMG_SERV+"/gfx/place/easter2020/game/items_all/ice/factory/"+i+".png";
            addImages["add"+i]=_IMG_SERV+"/gfx/place/easter2020/game/items_all/ice/add/"+i+".png";
            addImages["add"+i+"_factory"]=_IMG_SERV+"/gfx/place/easter2020/game/items_all/ice/add/"+i+"_factory.png";
        }
        addImages["ice2_part"]=_IMG_SERV+"/gfx/place/easter2020/game/items_all/ice/2_part.png";
        
        
        for (id in from_php.configs.iceConfig) {
            bum = from_php.configs.iceConfig[id];
            if(typeof need.ice_ids[bum.ice_id]!="undefined"){
                bum.img="ice"+bum.ice_id;
                bum.src=_IMG_SERV+"/gfx/place/easter2020/game/items_all/ice/"+bum.ice_id+".png";
                addImages[bum.img]=bum.src;
                if(bum.factory_ids.length>1){
                    addImages["ice"+bum.ice_id+"_part"]=_IMG_SERV+"/gfx/place/easter2020/game/items_all/ice/"+bum.ice_id+"_part.png";
                }
                for(i in bum.factory_ids){
                    factory_id=bum.factory_ids[i];
                    from_php.configs.factory[factory_id]={
                        img:"factory"+factory_id,
                        factory_id:factory_id,
                    };
                    addImages["factory"+factory_id]=_IMG_SERV+"/gfx/place/easter2020/game/items_all/ice/factory/"+factory_id+".png";

                }
                for(i in bum.add_ids){
                    add_id=bum.add_ids[i];
                    if(typeof need.add_ids[add_id]!="undefined"){
                        from_php.configs.add[add_id]={
                            img:"add"+add_id,
                            add_id:add_id,
                        };
                        addImages["add"+add_id]=_IMG_SERV+"/gfx/place/easter2020/game/items_all/ice/add/"+add_id+".png";
                        addImages["add"+add_id+"_factory"]=_IMG_SERV+"/gfx/place/easter2020/game/items_all/ice/add/"+add_id+"_factory.png";
                    }
                }
            }
        }
        from_php.configs.need=need;




        

        for(i in addImages){
            loaderMain.add(i,addImages[i]);
        }
        loaderMain.add("customer_bar",_IMG_SERV+"/gfx/place/easter2020/game/customer/customer_bar.jpg");
        loaderMain.add("clock_face",_IMG_SERV+"/gfx/place/easter2020/game/clock/face.png");
        loaderMain.add("clock_hand",_IMG_SERV+"/gfx/place/easter2020/game/clock/hand.png");

        loaderMain.add("progress_green",_IMG_SERV+"/gfx/place/easter2020/game/progressTime/green.png");
        loaderMain.add("progress_orange",_IMG_SERV+"/gfx/place/easter2020/game/progressTime/orange.png");
        loaderMain.add("progress_red",_IMG_SERV+"/gfx/place/easter2020/game/progressTime/red.png");
        loaderMain.add("plate",_IMG_SERV+"/gfx/place/easter2020/game/items_all/plate.png")

        loaderMain.add("comboBg",_IMG_SERV+"/gfx/place/easter2020/game/comboFill/comboBg.png");
        loaderMain.add("comboBoxBg",_IMG_SERV+"/gfx/place/easter2020/game/comboBox.png");
        loaderMain.add("comboFill_1",_IMG_SERV+"/gfx/place/easter2020/game/comboFill/1.png");
        loaderMain.add("comboFill_2",_IMG_SERV+"/gfx/place/easter2020/game/comboFill/2.png");
        loaderMain.add("comboFill_3",_IMG_SERV+"/gfx/place/easter2020/game/comboFill/3.png");
        loaderMain.add("comboFill_4",_IMG_SERV+"/gfx/place/easter2020/game/comboFill/4.png");


        loaderMain.add("girl_back",_IMG_SERV+"/gfx/place/easter2020/game/main/girl_back.png");
        var arr=["fill0","fill1","fill2","smoke","timer"];
        var keys=["big","medium"];
        for(i in arr){
            for(id in keys){
                loaderMain.add("customer_smoke_"+keys[id]+"_"+arr[i],_IMG_SERV+"/gfx/place/easter2020/game/timer/"+keys[id]+"/"+arr[i]+".png");
            }
        }
        loaderMain.add("customer_smoke_wrap",_IMG_SERV+"/gfx/place/easter2020/game/timer/item_wrap.png");
        
        loaderMain.add("customer_smoke",_IMG_SERV+"/gfx/place/easter2020/game/smoke.png");
        loaderMain.add("customer_smoke_shadow",_IMG_SERV+"/gfx/place/easter2020/game/part.png");

        loaderMain.add("checked",_IMG_SERV+"/gfx/place/easter2020/game/main/checked.png");
        loaderMain.add("cover_all",_IMG_SERV+"/gfx/place/easter2020/cover.png");
        loaderMain.add("down_center",_IMG_SERV+"/gfx/place/easter2020/down_center.png");
        
        
        loaderMain.add("combo_happy",_IMG_SERV+"/gfx/place/easter2020/game/combo/happy.png");
        loaderMain.add("combo_happy_box",_IMG_SERV+"/gfx/place/easter2020/game/combo/happy_box.png");
        
    },
    load:function(onEnd){
        this.loaderMain.load(function (f,r) {
            onEnd(r);
        });
    }
};